import { generateActionTypeIds } from "../generateActionTypeIds";
import { IKhoa } from "../../../model/respone/category/IKhoa";
import IGenericActionType from "../IGenericActionType";

export const eKhoaActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IKhoa[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IKhoa | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IKhoa,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

};
export const eKhoaActionIds = generateActionTypeIds(
  eKhoaActionsObj,
  "KHOA"
);
export type IKhoaActionTypes = IGenericActionType<
  typeof eKhoaActionsObj,
  "KHOA"
>;
